// extracted by mini-css-extract-plugin
export default {"container":"card_container__C42u3","card":"card_card__AX+SI"};